'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { useVSCSdkContext } from '@/context/VSCSdkContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { cn } from '@/lib/utils'

function Footer() {
  const ref = useRef<HTMLDivElement>(null)
  const { viverseShareComponent, changeLocale } = useVSCSdkContext()
  const enableFull3d = useEnableFull3d()
  const pathname = usePathname()
  const isExamplePage = pathname.includes('examples')

  useEffect(() => {
    if (enableFull3d || isExamplePage) return

    if (viverseShareComponent && ref.current) {
      viverseShareComponent.mountFooter({
        $footer: ref.current,
        layoutConfig: {
          type: 5,
        },
        localeConfig: {
          changeLocale,
        },
      })
    }
  }, [viverseShareComponent, changeLocale, enableFull3d, isExamplePage])

  return (
    <footer
      ref={ref}
      className={cn({
        hidden: enableFull3d,
      })}
    />
  )
}

export default Footer
